/**
 * Studio Notification Bell — appears in /studio header. Polls every 60s.
 */
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Bell } from "lucide-react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function NotifBell() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ items: [], unread_count: 0 });
  const ref = useRef(null);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/api/studio/notifications`, { withCredentials: true });
      setData(r.data);
    } catch (_) {}
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 60_000);
    const onClickAway = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("click", onClickAway);
    return () => { clearInterval(id); document.removeEventListener("click", onClickAway); };
  }, []);

  const markAll = async () => {
    try {
      await axios.post(`${API}/api/studio/notifications/mark-read?all=true`, {}, { withCredentials: true });
      toast.success("All marked read");
      load();
    } catch (_) {}
  };

  return (
    <div className="studio-bell-wrap" ref={ref} data-testid="studio-bell-wrap">
      <button
        className="studio-bell"
        onClick={() => setOpen((o) => !o)}
        data-testid="studio-bell"
        title="Notifications"
      >
        <Bell size={16}/>
        {data.unread_count > 0 && (
          <span className="studio-bell-badge" data-testid="studio-bell-badge">{data.unread_count}</span>
        )}
      </button>
      {open && (
        <div className="studio-bell-drawer" data-testid="studio-bell-drawer">
          <header>
            <strong>Notifications</strong>
            {data.unread_count > 0 && (
              <button className="studio-link" onClick={markAll} data-testid="studio-bell-mark-all">
                Mark all read
              </button>
            )}
          </header>
          {data.items.length === 0 ? (
            <p className="studio-muted" style={{ padding: 14, textAlign: "center" }}>No notifications yet</p>
          ) : (
            <ul>
              {data.items.slice(0, 12).map((n) => (
                <li key={n._id} className={n.read ? "" : "studio-bell-unread"} data-testid={`notif-item-${n._id}`}>
                  <Link
                    to={n.meta?.channel_id ? `/studio/channels/${n.meta.channel_id}#content-${n.meta.content_id}` : "/studio"}
                    onClick={() => setOpen(false)}
                  >
                    <strong>{n.title}</strong>
                    {n.detail && <span>{n.detail}</span>}
                    <small>{new Date(n.created_at).toLocaleString()}</small>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
